<template>
  <nav
    id="mobile-menu"
    class="mobile-menu bg-stone fixed right-0 top-0 pt-[81px] h-dvh w-dvw border-t border-light-green overflow-y-auto max-h-dvh z-40 flex-col justify-evenly"
    aria-label="Mobile Menu"
  >
    <ul class="flex flex-col gap-4 items-end pt-4">
      <li v-for="(item, index) in menuData" :key="index" class="w-full text-right">
        <a
          :href="item.url"
          class="body-xl underline text-black hover:text-light-grey w-full block px-4 py-2"
          @click="closeMenu"
          >{{ item.title }}</a
        >
      </li>
    </ul>
    <div class="p-4 pt-10 flex flex-col items-end">
      <a
        v-if="props.linkUrl"
        :href="props.linkUrl"
        :class="[
          'button',
          'button-large',
          'button-primary',
          props.linkTarget === '_blank' ? 'button-external' : ''
        ]"
        @click="closeMenu"
        >{{ props.linkText }}</a
      >
    </div>
    <div v-if="props.languages.length >= 1" class="flex flex-col items-end gap-y-2 pt-10 p-4">
      <p class="heading-sm">{{ props.languageHeading }}</p>
      <div class="flex gap-x-2">
        <component
          :is="lang.active ? 'p' : 'a'"
          v-for="lang in props.languages"
          :key="lang.language_code"
          :href="!lang.active ? lang.url : undefined"
          :class="['button button-primary button-small', { disabled: lang.active }]"
          role="menuitem"
          :aria-current="lang.active ? 'true' : undefined"
          :tabindex="lang.active ? undefined : 0"
        >
          {{ lang.native_name }} ({{ lang.language_code }})
        </component>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
const props = defineProps<{
  menuData: {
    title: string
    url: string
  }[]
  linkUrl: string
  linkText: string
  linkTarget: string
  languages: Array<{
    language_code: string
    native_name: string
    url: string
    active: string
  }>
  languageHeading: string
}>()

const closeMenu = () => {
  document.body.classList.remove('overflow-hidden')
  const menu = document.getElementById('mobile-menu')
  if (menu) {
    menu.classList.remove('menu-open')
  }
}
</script>

<style scoped></style>
